import React, { useState } from "react";

const PinCodeSearch = () => {
  const [pinCode, setPinCode] = useState("");
  const [location, setLocation] = useState({
    city: "",
    state: "",
    country: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchLocationByPinCode = async () => {
    if (!/^\d{6}$/.test(pinCode)) {
      setError("Please enter a valid 6-digit PIN code");
      return;
    }

    const pin_code = process.env.PIN_CODE_API_VALUE;
    console.log("PIN CODE : ", pin_code);
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${pinCode},India&key=AIzaSyDsoiNSiIk_5lskgRG7DM3UUxH-kK_Xtoc`,
      );

      const data = await response.json();

      if (data.status !== "OK" || !data.results.length) {
        setError("Location not found for this PIN code");
        return;
      }

      const addressComponents = data.results[0].address_components;

      let city = "";
      let state = "";
      let country = "";

      addressComponents.forEach((component) => {
        if (component.types.includes("locality")) {
          city = component.long_name;
        }

        if (component.types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }

        if (component.types.includes("country")) {
          country = component.long_name;
        }
      });

      setLocation({
        city,
        state,
        country,
      });
    } catch (error) {
      console.error("Error fetching location:", error);
      setError("Something went wrong while fetching location");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <input
        type="text"
        value={pinCode}
        maxLength={6}
        placeholder="Enter PIN code"
        onChange={(e) => setPinCode(e.target.value.replace(/\D/g, ""))}
      />

      <button onClick={fetchLocationByPinCode}>
        {loading ? "Fetching..." : "Get Location"}
      </button>

      {error && <p>{error}</p>}

      <div>
        <p>City: {location.city}</p>
        <p>State: {location.state}</p>
        <p>Country: {location.country}</p>
      </div>
    </div>
  );
};

export default PinCodeSearch;
